module.exports = __webpack_public_path__ + "static/media/993797.cf9a9aaa.png";